module.exports = __webpack_public_path__ + "media/2.fbb69de3.mp4";